import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-by': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M314.9 194.4v101.4h-28.3v120.5h-77.1v-120.4h-28.3v-101.5c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7h101.9c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zM213.4 130.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-by.js
// module id = 763
// module chunks = 0